import { handleActions } from 'redux-actions'

import { initialState, PaymentState } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils'

const actionsNames = [
  'fetchPennyPayment',
  'savePennyPayment',
  'submitAccountNumber',
  'pennyPaymentConfirm',
]

interface Actions {
  fetchPennyPayment: any
  pennyPaymentConfirm: any
  savePennyPayment: any
  submitAccountNumber: any
}

export const actions: Actions = prepareActions(actionsNames, 'signing') as Actions

export default handleActions<PaymentState, Payload>(
  {
    [actions.savePennyPayment]: (state: PaymentState, { payload }: any): PaymentState =>
      state
        .set('amount', payload.amount)
        .set('currentAccountNumber', payload.currentAccountNumber)
        .set('dueDate', payload.dueDate)
        .set('originalAccountNumber', payload.originalAccountNumber)
        .set('qrCode', payload.qrCode)
        .set('transactionNote', payload.transactionNote),
  },
  initialState
)
